// extracted by mini-css-extract-plugin
export default {"root":"CandidateBackyPortal_root__UU7LL","frameWrapper":"CandidateBackyPortal_frameWrapper__U8V2W"};